export class SecurityAdjustmentFactor{
    id:number;
    values:SecurityAdjustmentFactorValue[];
}
export class SecurityAdjustmentFactorValue{
    securitytId:number;
    value:number;
}